import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useGetSalesQuery } from '../../../../entities/sales/sales.api';
import { selectUser } from '../../../../store/user/user.selector';

// styles
import {
    SalesListingsContainer,
    ListingsListContainer,
    ListingsList,
    EmptyState
} from './SalesTracker.styles.js';

// components
import PrimaryBtn from '../../../../components/btns/primary-btn/PrimaryBtn';
import ListingCard from './components/listing-card/ListingCard';
import CreateSaleModal from './components/create-sale-modal/CreateSaleModal.js';

export default function SalesTracker() {
  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const { data: sales = [], isLoading, error } = useGetSalesQuery(
    { uid: user?.uid },
    { skip: !user?.uid }
  );

  const handleCreateSuccess = () => {
    setShowCreateModal(false);
  };

  const handleSaleClick = (sale) => {
    navigate(`/transactions/tracker/${sale.id}`);
  };

  return (
    <SalesListingsContainer>
      <ListingsListContainer>

        {isLoading && <h3>Loading sales...</h3>}

        {error && <h3>Error loading sales: {error.message}</h3>}

        {sales.length === 0 && !isLoading ? (
          <EmptyState>
            <h2>No sales yet</h2>
            <p>Add your first sale to start tracking!</p>
            <PrimaryBtn 
              title="Add a sale" 
              onClick={() => setShowCreateModal(true)} 
            />
          </EmptyState>
        ) : (
          <ListingsList>
            {sales.map((sale) => (
              <ListingCard
                key={sale.id}
                sale={sale}
                onClick={() => handleSaleClick(sale)}
              />
            ))}
          </ListingsList>
        )}
      </ListingsListContainer>

      {showCreateModal && (
        <CreateSaleModal
          isOpen={showCreateModal}
          onClose={() => setShowCreateModal(false)}
          onSuccess={handleCreateSuccess}
        />
      )}
    </SalesListingsContainer>
  );
}

